// @flow
import * as React from 'react';
import {
    View, Text, StyleSheet, Platform,
} from 'react-native';
import { renderNode } from 'react-native-elements/dist/helpers';
import { fonts, ThemeContext } from 'react-native-elements/dist/config';
import FieldWrapper, { type Props } from './FieldWrapper';
import { useFormattedFieldErrors } from './utils';


const renderText = (content, defaultProps, style) => renderNode(Text, content, {
    ...defaultProps,
    style: StyleSheet.flatten([style, defaultProps && defaultProps.style]),
});

// Styles taken from react-native-elements/src/input/Input.js
const styles = {
    container: {
        width: '100%',
        paddingHorizontal: 10,
    },
    error: (theme) => ({
        margin: 5,
        fontSize: theme.fontsizes.textSmall,
        color: theme.colors.danger,
    }),
    label: (theme) => ({
        fontSize: theme.fontsizes.categoryTitle,
        color: theme.colors.defaultTextColor,
        ...Platform.select({
            android: {
                ...fonts.android.bold,
            },
            default: {
                fontWeight: 'bold',
            },
        }),
    }),
};


type RNEProps = Props & {
    label: string,
    required: boolean,
    touched: boolean,
    errors: string | Array<string> | Object | null,
};


const FieldWrapperRNE = (props: RNEProps): React.Node => {
    const {
        children, label, required, errors, touched, ...rest
    } = props;

    const { theme } = React.useContext(ThemeContext);
    const errs = useFormattedFieldErrors(errors);

    return (
        <FieldWrapper {...rest}>
            <View style={styles.container}>
                {renderText(
                    required ? `${label} *` : label,
                    {},
                    styles.label(theme),
                )}
                {children}
                {
                    touched && errs && (
                        <Text style={styles.error(theme)}>
                            {errs}
                        </Text>
                    )
                }
            </View>
        </FieldWrapper>
    );
};
export default FieldWrapperRNE;
